<template>
  <div class="user-portrate" :class="displaySize">
    <img :src="'/api' + target.icon_img_path" class="icon-image" v-if="target && target.icon_img_path" />
    <div class="generated-icon-image" :style="{ backgroundColor: themeBackground }" v-if="target && !target.icon_img_path">
      <div class="generated-icon-inner">{{ target.name.charAt(0) }}</div>
    </div>
  </div>
</template>

<script>
// import crypto from 'crypto-js'

export default {
  name: 'UserPortrate',

  props: {
    target: Object,
    displaySize: String
  },

  computed: {
    themeBackground () {
      if (this.target.theme_color) {
        return this.target.theme_color
      } else {
        // cryptoでaccount_nameをハッシュして数値化、mod計算して256までの整数にする
        const CryptoJS = require('crypto-js')
        console.log('#' + (parseInt('0x' + CryptoJS.MD5(this.target.name).toString(CryptoJS.enc.Hex), 16) % 16777215).toString(16))
        return '#' + (parseInt('0x' + CryptoJS.MD5(this.target.name).toString(CryptoJS.enc.Hex), 16) % 16777215).toString(16)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-portrate {
  display: inline-block;
  &.large {
    // height: 180px;
    width: 180px;
    aspect-ratio: 1;
    // margin: auto;
    .generated-icon-image {
      width: 180px;
      height: 180px;
      .generated-icon-inner {
        width: calc(180px * 0.75);
        height: calc(180px * 0.75);
        font-size: calc(180px * 0.75);
      }
    }
    img {
      width: 180px;
    }
  }
  &.middle {
    // height: 50px;
    width: 50px;
    aspect-ratio: 1;
    // margin: auto;
    .generated-icon-image {
      width: 50px;
      height: 50px;
      .generated-icon-inner {
        width: calc(50px * 0.75);
        height: calc(50px * 0.75);
        font-size: calc(50px * 0.75);
      }
    }
    img {
      width: 50px;
    }
  }
  &.small {
    // height: 40px;
    width: 40px;
    aspect-ratio: 1;
    // margin: auto;
    .generated-icon-image {
      width: 40px;
      height: 40px;
      .generated-icon-inner {
        width: calc(40px * 0.75);
        height: calc(40px * 0.75);
        font-size: calc(40px * 0.75);
      }
    }
    img {
      width: 40px;
    }
  }
  &.mini {
    width: 24px;
    aspect-ratio: 1;
    margin: auto;
    .generated-icon-image {
      width: 24px;
      height: 24px;
      .generated-icon-inner {
        width: calc(24px * 0.75);
        height: calc(24px * 0.75);
        font-size: calc(24px * 0.75);
      }
    }
    img {
      width: 24px;
    }
  }
  .icon-image {
    display: inline-block;
    // width: 100%;
    // height: 100%;
    border-radius: 50%;
  }
  .generated-icon-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    .generated-icon-inner {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      font-size: calc(80% + 1px)px;
    }
  }
}
</style>